import React from "react";

const QrCodeFilledIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={cls}
    >
      <path
        d="M4.5625 20.636H7.625V23.261H4.5625C2.87375 23.261 1.5 21.8872 1.5 20.1985V17.136H4.125V20.1985C4.125 20.44 4.321 20.636 4.5625 20.636ZM19.875 20.1985C19.875 20.44 19.679 20.636 19.4375 20.636H16.375V23.261H19.4375C21.1262 23.261 22.5 21.8872 22.5 20.1985V17.136H19.875V20.1985ZM19.4375 2.26099H16.375V4.88599H19.4375C19.679 4.88599 19.875 5.08199 19.875 5.32349V8.38599H22.5V5.32349C22.5 3.63474 21.1262 2.26099 19.4375 2.26099ZM4.125 5.32349C4.125 5.08199 4.321 4.88599 4.5625 4.88599H7.625V2.26099H4.5625C2.87375 2.26099 1.5 3.63474 1.5 5.32349V8.38599H4.125V5.32349ZM5.875 11.886H11.125V6.63599H5.875V11.886ZM18.125 6.63599H12.875V11.886H18.125V6.63599ZM5.875 18.886H11.125V13.636H5.875V18.886ZM18.125 13.636H15.5V16.261H18.125V13.636ZM12.875 18.886H15.5V16.261H12.875V18.886Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default QrCodeFilledIcon;
